import gql from 'graphql-tag';
import hirerGraphqlClient from './client';

export const query = gql`
  query Questionnaire(
    $questionnaireId: String!
    $adcentreAdvertiserId: String!
  ) {
    questionnaire(
      id: $questionnaireId
      adcentreAdvertiserId: $adcentreAdvertiserId
    ) {
      id
      questions {
        id
        globalId
        text
        statement
        essential
        order
        source
        answerType
        answers {
          id
          globalId
          text
          isPreferred
          order
        }
        hirerExperience {
          controlType
          selectionType
          simplifiedAnswers {
            id
            globalId
            text
            answerIds
            answerGlobalIds
            isPreferred
            order
          }
          mandatory {
            mandatoryAnswerText
          }
        }
      }
    }
  }
`;

const fetchQuestionnaire = async (
  questionnaireId: string,
  adcentreAdvertiserId: string,
) => {
  const { data } = await hirerGraphqlClient.query({
    variables: { questionnaireId, adcentreAdvertiserId },
    query,
  });

  return data.questionnaire;
};

export default fetchQuestionnaire;
